import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
import { EnrichedService } from '../../types/types';

export const showExplorePlansForService = (service: EnrichedService) =>
  service.payment?.pricingPlanIds?.length! > 0 &&
  service?.type !== ServiceType.COURSE &&
  !service.displayOnlyNoBookFlow &&
  !service.onlineBooking?.requireManualApproval;
